import { Skeleton } from '../../../../feedback/Skeleton';
import { Flex, FlexProps } from '../../../../layout/Flex';
import { Wrapper } from '../../styles';

export const AdvertisingShopCardSkeleton: React.FC<FlexProps> = (props) => (
    <Wrapper height="200px" {...props}>
        <Flex direction="row" alignItems="center" width="100%" spacing={1} pt={0.5}>
            <Flex
                width="32px"
                height="32px"
                background="var(--placeholder)"
                backgroundSize="cover"
                borderRadius="100%"
                flexShrink={0}
            />
            <Skeleton variant="rect" width={150} height={20} borderRadius={1} />
        </Flex>
        <Skeleton variant="rect" width="100%" height={56} borderRadius={1} my={1.5} />
        <Flex width="100%" mt="auto">
            <Flex direction="row" spacing={0.5} flexWrap="wrap" pb={1}>
                <Skeleton variant="rect" width={90} height={20} borderRadius={1} />
                <Skeleton variant="rect" width={50} height={20} borderRadius={1} />
            </Flex>
            <Skeleton variant="rect" width="100%" height={40} borderRadius={1} />
        </Flex>
    </Wrapper>
);
